import { ui } from '@libs/domain';
import { useItemNames } from '@ps-smart-cp/ppfw-client';
import { type ChangeEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AdminLoginCredentials,
  FormSection,
  LoginContainer,
  LoginInputField,
  StyledLoginButton,
  adminSignIn,
} from '../features/login';
import { useTryShell } from '../hooks';

export function AdminLogin() {
  const navigate = useNavigate();
  const { tryRequest, error, setError } = useTryShell();

  const [credentials, setCredentials] = useState(AdminLoginCredentials.init);

  const titleNames = useItemNames(ui.titleNames);
  const labelNames = useItemNames(ui.labelNames);
  const buttonNames = useItemNames(ui.buttonNames);

  const onChange = (e: ChangeEvent<HTMLInputElement>) =>
    setCredentials({ ...credentials, [e.currentTarget.name]: e.currentTarget.value });

  // AUTH-333 エラーメッセージのローカライズ
  const onAdminLogin = async () =>
    await tryRequest(async () => {
      if (credentials.email === '' || credentials.password === '') {
        setError(
          '【ログインエラー】指定されたメールアドレス、パスワードに一致するアカウントがありません。(EFW56012)',
        );
        return;
      }

      await adminSignIn(credentials);
      navigate('/system-management/main-menu');
    });

  return (
    <LoginContainer title={titleNames('adminLogin')} error={error}>
      <FormSection>
        <LoginInputField
          id="email"
          name="email"
          label={`${labelNames('email')}*`}
          value={credentials.email}
          onChange={onChange}
          onEnter={onAdminLogin}
        />
        <LoginInputField
          id="password"
          name="password"
          label={`${labelNames('password')}*`}
          value={credentials.password}
          onChange={onChange}
          onEnter={onAdminLogin}
          type="password"
        />
      </FormSection>
      <FormSection>
        <StyledLoginButton id="login-btn" displayName={buttonNames('login')} onClick={onAdminLogin} />
        <StyledLoginButton
          id="return-btn"
          displayName={buttonNames('return')}
          onClick={() => navigate('/')}
        />
      </FormSection>
    </LoginContainer>
  );
}
